import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';

import { RequestService } from '../request';
import { ICreateUpdateQueryRequest, IQuery } from './defs';
import { RuleSet } from '@app/shared/condition-builder';

@Injectable({
  providedIn: 'root',
})
export class QueryService {
  private baseUrl = '/api/queries';

  constructor(private request: RequestService) {}

  public getList(): Observable<IQuery[]> {
    return this.request.get(this.baseUrl);
  }

  public getQueryById(id: number): Observable<IQuery> {
    return this.request.get(`${this.baseUrl}/${id}`);
  }

  public getSqlFromRuleset(ruleset: RuleSet): string {
    return ruleset.rules
      .map((rule) => {
        if (rule.rules) {
          return '(' + this.getSqlFromRuleset(rule) + ')';
        }
        var column = rule.field,
          operator,
          value;

        switch (rule.operator) {
          case 'is null':
          case 'is not null':
            operator = rule.operator;
            value = '';
            break;
          case 'in':
          case 'not in':
            operator = rule.operator;
            if (Array.isArray(rule.value) && rule.value.length)
              value =
                '(' +
                rule.value
                  .map(this.valueToSQL)
                  .filter(this.isDefined)
                  .join(', ') +
                ')';
            break;
          default:
            operator = rule.operator;
            value = this.valueToSQL(rule.value);
            break;
        }

        if (
          this.isDefined(column) &&
          this.isDefined(value) &&
          this.isDefined(operator)
        ) {
          return '(' + (column + ' ' + operator + ' ' + value).trim() + ')';
        }

        return undefined;
      })
      .filter(this.isDefined)
      .join(' ' + ruleset.condition + ' ');
  }

  private valueToSQL(value): any {
    switch (typeof value) {
      case 'string':
        return "'" + value + "'";
      case 'boolean':
        return value ? '1' : '0';
      case 'number':
        if (isFinite(value)) {
          return value;
        }
    }

    return value;
  }

  private isDefined(value) {
    return value !== undefined;
  }

  public createUpdateQuery(
    request: ICreateUpdateQueryRequest
  ): Observable<IQuery> {
    if (!request.id) {
      return this.request.post(this.baseUrl, request);
    }
    return this.request.put(`${this.baseUrl}/${request.id}`, request);
  }

  public deleteQuery(ids: number[]): Observable<IQuery[]> {
    return forkJoin(
      ids.map((id) => this.request.delete(`${this.baseUrl}/${id}`))
    );
  }
}
